'use strict';

var React = require('react');

var SvgMobileBackArrowMajor = function SvgMobileBackArrowMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-15.339l5.997-5.246a1 1 0 0 0-1.316-1.506l-8 7c-.008.007-.011.018-.019.025a.975.975 0 0 0-.177.24c-.018.03-.045.054-.059.087a.975.975 0 0 0 0 .802c.014.033.041.057.059.088.05.087.104.17.177.239.008.007.011.018.019.025l8 7a.996.996 0 0 0 1.411-.095 1 1 0 0 0-.095-1.411l-5.997-5.248h15.339a1 1 0 0 0 0-2z"
  }));
};

exports.SvgMobileBackArrowMajor = SvgMobileBackArrowMajor;
